module.exports = "<div class=\"duration-container\">\n  <div class=\"plus-button unselectable\" (click)=\"onPlus()\">\n    <mat-icon>add</mat-icon>\n  </div>\n  <div class=\"duration-value\">\n    <input type=\"number\" [(ngModel)]=\"duration\">\n    <span class=\"duration-unit\">روز</span>\n  </div>\n  <div class=\"minus-button unselectable\" (click)=\"onMinus()\">\n    <mat-icon>remove</mat-icon>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/duration-selector/duration-selector.component.html
// module id = 1152
// module chunks = 0